import { Suspense, lazy } from 'react';
import GameCardsLineSkeleton from '../GameCardsLine/Skeleton';
const ProvidersLine = lazy(() => import('./ProvidersLine'));

const ProvidersLineAsync = (props) => (
  <Suspense fallback={<GameCardsLineSkeleton {...props} />}>
    <ProvidersLine {...props} />
  </Suspense>
);

export default ProvidersLineAsync;
